export enum SimulationTypeEnum {
  ROLE_PLAY = 'ROLE_PLAY',
  KNOWLEDGE_CHECK = 'KNOWLEDGE_CHECK',
}
